<template lang="pug">
  .table-responsive
    table#tbExistencias.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Entrega
          th Anterior
          th Actual
          th Área
          th Ubicación
          th Fecha Reg.
      tbody
        tr
          td #
          td Entrega
          td Anterior
          td Actual
          td Área
          td Ubicación
          td Fecha Reg.
          
</template>

<script>
  export default {
    name: 'TablaReasignaciones'
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TablaReasignaciones.vue